<!--
  功能：功能描述
  作者：xixi
  时间：2021年12月15日 16:03:19
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="container">
    <div class="header">
      <div class="header-left">
        <el-image
          class="elder-image"
          fit="cover"
          :src="
            elder.ImgUrl ? elder.ImgUrl : avatar
          "
        ></el-image>
        <div>
          <div class="name">{{ elder.Name }}</div>
          <div class="level-room">
            <span class="level">{{ elder.CareLevel }}</span>
            <span class="room">房号： {{ elder.Room }}</span>
          </div>
        </div>
      </div>
      <div class="btn-container">
        <!-- <div class="btn del-btn">删除图片</div> -->
        <div class="btn up-btn" @click="showPopup">上传图片</div>
      </div>
    </div>
    <div v-loading="fullscreenLoading" class="masonry">
      <div
        v-for="(item, index) in imagesList"
        class="img-item"
        :key="index"
        @click="openImg1(index)"
      >
        <img :src="item.ImgUrl" alt="" />
        <div class="dele1" @click.stop="deleImg1(item.ImgUrl, index)">
          <van-icon name="clear" />
        </div>
      </div>
    </div>
    <van-popup
      v-model="show"
      round
      :style="{ height: '60%' }"
      @close="closePopup"
      :close-on-click-overlay="false"
    >
      <div class="popup">
        <div class="popup-title">
          <p>上传图片</p>
          <div class="close" @click="clickClosePopup">
            <van-icon name="cross" size="20" color="#707070" />
          </div>
        </div>
        <div class="up-content">

          <div
            class="up-item"
            v-for="(item, index) in uploadImages"
            :key="index"
            @click="openImg(uploadImages, index)"
          >
            <img class="image" :src="item" />
            <div class="dele" @click.stop="deleImg(item, index)">
              <van-icon name="clear" />
            </div>
          </div>
          <!-- <input id="file" @change="handleFileChange" type="file" accept="image/*" name="file" /> -->
          <!-- <input type="file"  @change="handleFileChange" id="fileElem" accept="image/*" class="visually-hidden"> -->
          <!-- <label for="fileElem">Select some files</label> -->

          <van-uploader :before-read="beforeRead" :after-read="afterRead"  accept="image/*" :max-count="9" multiple></van-uploader>
        </div>
        <div class="up-bottom">
          <div @click="saveData">上传图片</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ImagePreview } from "vant";
import { Toast } from 'vant';
import { Dialog } from 'vant';
import avatar from "@/assets/imgs/avatar.png";
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      fullscreenLoading: false,
      imagesList: [],
      // fileList: [],
      uploadImages: [],
      show: false,
      delLoading:false,
      isUploadImages:false,
      avatar
    };
  },
  // 计算属性
  computed: {
    ...mapState(["ElderlyCares"]),
    elder() {
      return this.ElderlyCares.filter(
        (item) => item.Id == this.$route.query.Id
      )[0];
    },
  },
  // 侦听器
  watch: {
    uploadImages(val,oldVal){
      if(val.length>0){
        this.isUploadImages=true
      }
    }
  },
  // 组件方法
  methods: {

    // handleFileChange(e){
    //   let formData = new FormData();
    //   const files = e.target.files;
    //   if(files && files[0]) {
    //     const file = files[0];
    //     formData.append("file", file);
    //    this.$axios.post("/QiNiu/UploadFile",formData).then((res) => {
    //       console.log(res.data);
    //       res.data.obj.forEach((item) => {
    //         this.uploadImages.push(item.Value);
    //       });
    //     })
    //     .catch((err) => {});
    //   }
    // },
    showPopup() {
      this.show = true;
      // this.fileList = [];
      // this.uploadImages = [];
    },
    clickClosePopup(){
      if(this.isUploadImages){
        Dialog.confirm({
          title: '',
          message: '当前图片未保存，是否退出？',
        }).then(() => {
          this.show = false;
        }).catch(()=>{});
      }else{
        this.show = false;
      }
    },
    closePopup() {
      // this.fileList = [];
      this.uploadImages = [];
      this.isUploadImages=false
    },
    getPhotos() {
      this.fullscreenLoading = true;
      this.$axios.get("/Pad/GetProfileImage?profileId=" + this.elder.Id)
        .then((res) => {
          this.fullscreenLoading = false;
          this.imagesList = res.data.obj;
        })
        .catch((err) => {
          this.fullscreenLoading = false;
        });
    },
    beforeRead(){
      Toast.loading({
        message: '上传中...',
      });
      return true
    },
    afterRead(file) {
     console.log("sdasdadasds");
      let formData = new FormData();
      if (!Array.isArray(file)) {
        file = [file];
      }
      for (let i = 0; i < file.length; i++) {
        file[i].status = "uploading";
        file[i].message = "上传中...";
        formData.append("file", file[i].file);
        this.$axios.post( "/QiNiu/UploadFile",  formData).then((res) => {
                console.log(res.data);
          file[i].message = "";
          file[i].status = "done";

          res.data.obj.forEach((item) => {
            this.uploadImages.push(item.Value);
          });
          Toast.clear();
        })
        .catch((err) => {
          console.log("出错了");
          console.log(err);
          Toast.clear();
        });
      }
    },
    deleImg(item, index) {
      if(this.delLoading) return;
      this.delLoading=true
      this.$axios.post( "/QiNiu/DeleteFile?path=" + item)
      .then((res) => {
        this.delLoading=false
        this.uploadImages.splice(index, 1);
      })
      .catch((err) => {
        this.delLoading=false
      });
    },
    deleImg1(item, index) {
      if(this.delLoading) return;
      this.delLoading=true
      this.$axios
      .post(
        "/Pad/DeleteImage?profileId=" +
          this.elder.Id +
          "&src=" +item
      )
      .then((res) => {
        this.delLoading=false
        Toast.success('删除成功');
        this.getPhotos();
      })
      .catch((err) => {
        this.delLoading=false
      });
    },
    openImg(item, index) {
      ImagePreview({
        images: item,
        startPosition: index,
        closeable: true,
      });
    },
    openImg1(index) {
      ImagePreview({
        images: this.imagesList.map((item) => {
          return item.ImgUrl;
        }),
        startPosition: index,
        closeable: true,
      });
    },
    saveData() {
      if (this.uploadImages.length > 0) {
        Toast.loading({
          message: '上传中...',
        });
        this.$axios
          .post(
            "/Pad/SaveImg?profileId=" +
              this.elder.Id +
              "&uploadsUrl=" +
              this.uploadImages.join(",")
          )
          .then((res) => {
            this.show = false;
            Toast.clear();
            Toast.success('上传成功');
            this.getPhotos();
          })
          .catch((err) => {
            Toast.clear();
          });
      }
    },
  },
  beforeCreate() {},
  created() {
    this.getPhotos();
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 44px);
}
.header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 13px 15px;
  background: #ffffff;
}
.header-left {
  display: flex;
  align-items: center;
}
.elder-image {
  width: 42px;
  height: 42px;
  margin-right: 12px;
  border-radius: 21px;
  border: 1px solid #029fd1;
  overflow: hidden;
}
.name {
  font-size: 16px;
  line-height: 23px;
  font-weight: 500;
  color: #0a0e10;
}
.level-room {
  font-size: 12px;
  font-weight: 400;
  line-height: 34px;
}
.level {
  color: #7c7e80;
}
.room {
  color: #029fd1;
}
.btn-container {
  display: flex;
}
.btn {
  width: 61px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 2px;
  color: #fff;
  font-size: 10px;
}
.del-btn {
  background: #f32e2f;
}
.up-btn {
  background: #029fd1;
  margin-left: 8px;
}

.masonry {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  flex: 1;
  /* width: 100%; */
  width: calc(100% + 10px);
  box-sizing: border-box;
  padding: 12px 15px;
  overflow: auto;
}
.img-item {
  width: 168px;
  height: 200px;
  /* margin-left: 20px;
  margin-bottom: 20px; */
  margin: 0px 10px 10px 0px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.dele1 {
  width: 25px;
  height: 25px;
  position: absolute;
  top: 0;
  right: 0;
}
.dele1 .van-icon {
  font-size: 25px;
}
.masonry .img-item:nth-child(2n) {
  margin-left: 0;
}
.img-item img {
  width: 100%;
  height: 100%;
}
.item {
  position: relative;
  width: 25%;
  padding: 1px;
  box-sizing: border-box;
  counter-increment: item-counter;
}
.item img {
  display: block;
  width: 100%;
  height: auto;
}

.item::after {
  position: absolute;
  display: block;
  top: 1px;
  left: 1px;
  width: 12px;
  height: 12px;
  text-align: center;
  line-height: 12px;
  background-color: #000;
  color: #fff;
  content: counter(item-counter);
}
.item:nth-child(4n + 1) {
  order: 1;
}
.item:nth-child(4n + 2) {
  order: 2;
}
.item:nth-child(4n + 3) {
  order: 3;
}
.item:nth-child(4n) {
  order: 4;
}
.popup {
  width: 335px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.popup-title {
  position: relative;
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #ebebeb;
  font-size: 18px;
  color: #0a0e10;
  text-align: center;
  line-height: 50px;
}
.popup-title p {
  margin: 0;
}
.close {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
}
.up-content {
  width: 100%;
  flex: 1;
  overflow: auto;
  box-sizing: border-box;
  align-content: flex-start;
  padding: 12px;
  display: flex;
  flex-wrap: wrap;
}
.up-item {
  width: 98px;
  height: 98px;
  border-radius: 2px;
  margin-right: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  position: relative;
}
.dele {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  right: 0;
}
.dele .van-icon {
  font-size: 18px;
}
.up-item img {
  width: 100%;
  height: 100%;
}
.up-item:nth-child(3n) {
  margin-right: 0;
}

.up-bottom {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}
.up-bottom div {
  width: 100%;
  height: 40px;
  background: #029fd1;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  color: #fff;
}
</style>
<style>
.up-content .van-uploader {
  width: 98px;
  height: 98px;
}
.up-content .van-uploader__preview,
.up-content .van-uploader__upload {
  width: 91px;
  height: 91px;
  border-radius: 2px;
  margin-right: 8px;
  margin-bottom: 8px;
  overflow: hidden;
}
.up-content .van-uploader__preview:nth-child(3n) {
  margin-right: 0;
  margin-bottom: 8px;
}
.up-content .van-uploader__upload {
  margin-right: 0;
  margin-bottom: 8px;
}
.up-content .van-uploader__preview-image {
  width: 100%;
  height: 100%;
}
.up-content .van-uploader__preview-delete {
  width: 25px;
  height: 25px;
}
.up-content .van-uploader__preview-delete-icon {
  font-size: 36px;
  top: -5px;
  right: -5px;
}
.up-item .van-uploader__upload,
.up-item .van-uploader,
.up-item .van-uploader__wrapper,
.up-item .van-uploader__preview-image {
  width: 100%;
  height: 100%;
}
.up-content .van-uploader__upload-icon {
  font-size: 30px;
}
.van-toast{
  width: 75px;
}



</style>



// WEBPACK FOOTER //
// src/components/photo.vue